import { Group, Text } from "@mantine/core";
import { DataGridPage, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { AppSupervisor } from "./AppSupervisor";

export const ACTVerPersonalTienda: EntityClientAction = {
    name: 'ACTVerPersonalTienda',
    label: 'Ver Personal',
    title: <Text fw={700}>Ver Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['apsp_brwTiendas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as AppSupervisor;
        parent.def.columns.c_tienda_id.value = selectedKeys![0].c_tienda_id as unknown as string || '';

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Personal</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <DataGridPage
                key="personal-tienda"
                client={entity.API.client}
                entityConstructor={() => parent}
                formMode="edit"
                viewName="apsp_brwTiendasPersonal"
                refreshOnInit
                enableAdd={false}
                enableDelete={false}
                enableEdit={false}
                enableView={false}
                title="Ver Personal"
                selectionMode="single" />          
        });

        return false;
    }
}